import Sidebar from "../components/Sidebar";
import MyPageHeader from "../components/Header/MyPageHeader";
import React, {useState} from "react";
import neverLandUtils from "../utils/NeverLandUtils";
import {accountInfo} from "../constants/constants";
import {useNavigate} from "react-router-dom";
import {updateMyInfo} from "../utils/NeverLandRestFULInterface";
import VolumeRangeSlider from "../components/VolumeRangeSlider";
import {mobileInterface} from "./WindowInterfaces";
import {RiCheckFill, RiCloseFill} from "react-icons/ri";

const MySettingPage = () => {
  const [volumeToggleStates, setVolumeToggleStates] = useState({});
  const navigate = useNavigate();

  const [alarmSettings, setAlarmSettings] = useState([
    {
      title: '초기값',
      options:
          [
            {name: "메인화면 조회조건 테이블 펼치기", isOn: false, key: 'on_show_filter_table'}
          ]
    },
    {
      title: '자동화',
      options:
          [
            {name: "요청시 페이지 넘어가기", isOn: true, key: 'on_route_page'},
            {name: "요청시 선택한 경기 초기화", isOn: true, key: 'on_refresh_select_game'},
          ]
    },
    {
      title: '알람',
      options:
          [
            {name: "전체 알람", isOn: true, key: 'on_notification_all', volume: 3, isMaster: true}, // 부모 옵션
            {name: "추천인 승인 알람", isOn: false, key: 'on_store_confirm', volume: 3, dependsOn: 'on_notification_all'},
            {name: "추천인 승인 요청 알람ⓢ", isOn: false, key: 'on_confirm_request', volume: 3, dependsOn: 'on_notification_all'},
            {name: "예측 등록 알람ⓢ", isOn: false, key: 'on_request_register', volume: 3, dependsOn: 'on_notification_all'},
            {name: "배팅 알람", isOn: false, key: 'on_request_print', volume: 3, dependsOn: 'on_notification_all'},
            // {name: "경기 결과 알람", isOn: false, key: 'on_game_result', volume: 3}
          ]
    },
    {
      title: '화면',
      options:
          [
            {name: "게임 정보 큰 폰트 적용", isOn: false, key: 'use_large_font'},
            {name: "게임 정보 돋보기 모드 사용", isOn: false, key: 'use_magnifier_mode'},
          ]
    },
    {
      title: '기타설정',
      options:
          [
            {name: "음소거", isOn: false, key: 'on_mute'},
            // {name: "간편모드", isOn: true, key: 'use_simple_mode'},   // 현재 간편모드 고정
            {name: "폴더 중복 선택", isOn: false, key: 'folder_toggle_mode'},
          ]
    }
  ]);

  const  checkHideDependOptions = (option, accountInfo) => {
    // dependsOn 속성이 있는 경우
    if (option.dependsOn) {
      // Master옵션이 켜져있는지 확인
      return !accountInfo.getUserConfig().isOn(option.dependsOn, true);
    }
    return false;
  };

  const toggleAlarmSetting = (name, boolean, volume = null) => {
    let updatedAlarmSettings = [...alarmSettings];
    let alarmSettingIndex;
    let optionsIndex = -1;
    let tempIndex;

    alarmSettingIndex = updatedAlarmSettings.findIndex(list => {
      if (-1 !== (tempIndex = list.options.findIndex(opt => opt.name === name))) {
        optionsIndex = tempIndex;
        return true;
      }
      return false;
    });

    if (alarmSettingIndex !== -1 && optionsIndex !== -1) {
      let currentOption = updatedAlarmSettings[alarmSettingIndex].options[optionsIndex];
      let key = currentOption.key;

      // 현재 옵션의 state 업데이트
      updatedAlarmSettings[alarmSettingIndex].options[optionsIndex].isOn = boolean;

      // 현재 옵션의 ON/OFF 저장
      accountInfo.getUserConfig().setOptionOn(key, boolean);

      // 볼륨값이 직접 전달된 경우 볼륨 설정 (슬라이더에서 변경)
      if (volume !== null) {
        accountInfo.getUserConfig().setOptionOn(`${key}_volume`, volume);
      }

      // 마스터 옵션인 경우 하위 옵션들도 함께 변경
      if (currentOption.isMaster) {
        // 같은 카테고리 내에서 현재 마스터에 의존하는 모든 옵션들 찾기
        updatedAlarmSettings[alarmSettingIndex].options.forEach((option, index) => {
          if (option.dependsOn === key) {
            // 하위 옵션도 마스터와 동일하게 설정
            updatedAlarmSettings[alarmSettingIndex].options[index].isOn = boolean;
            accountInfo.getUserConfig().setOptionOn(option.key, boolean);

            console.log(`마스터 변경에 따른 하위 옵션 변경: ${option.key} -> ${boolean}`);
          }
        });
      }

      console.log('toggleAlarmSetting->' + key);
      mobileInterface.mobile_config_commit();
      setAlarmSettings([...updatedAlarmSettings]);
    }
  }

  const toggleVolumeSlider = (optionKey) => {
    setVolumeToggleStates(prev => ({
      ...prev,
      [optionKey]: !prev[optionKey]
    }));
  };

  return (
      <>
        <div>
          <Sidebar/>
          <div className="lg:pl-64">
            <MyPageHeader/>
            <main>
              <div className="lg:mt-12 divide-y divide-gray-300">
                {alarmSettings.map((category) => {
                  return (
                      <div
                          className="grid max-w-full grid-cols-1 gap-x-8 gap-y-10 px-4 py-6 sm:py-16 sm:px-6 md:grid-cols-3 lg:px-8">

                        {/* <-- 대분류 --> */}
                        <div className="sm:ml-10">
                          <h2 className="text-xl font-semibold leading-7 text-gray-900">{category.title}</h2>
                        </div>

                        <div className="md:col-span-2">
                          <div className="gap-x-6 gap-y-8 sm:max-w-xl">
                            {category.options.map((option) => {
                              // 지점여부 체크
                              if (option.name.includes("ⓢ") && !accountInfo.isStore()) {
                                return <></>;
                              }

                              // Master/DependsOn 시스템 체크 - Master가 off 일때 dependOn 걸려있는 옵션들 숨기기
                              if (checkHideDependOptions(option, accountInfo)) {
                                return <></>;
                              }

                              let isOptionOn = accountInfo.getUserConfig().isOn(option.key, option.isOn);
                              let isVolumeOpen = volumeToggleStates[option.key] || false;
                              let currentVolume = accountInfo.getUserConfig().isOn(`${option.key}_volume`, option.volume);
                              return (
                                  <div
                                      className="mb-10 sm:pr-32">
                                    {/* <-- 소분류 --> */}
                                    <div className="flex flex-row whitespace-nowrap items-center justify-between">
                                      <div className="flex items-center gap-4">
                                        <label htmlFor="optionName"
                                               className="block text-md sm:text-lg font-semibold leading-6 text-gray-900">
                                          {option.name.replace("ⓢ", "")}
                                        </label>

                                        {/* <-- 볼륨 토글 버튼 (알람 카테고리에만 표시) --> */}
                                        {category.title === '알람' && (
                                            <button
                                                onClick={() => toggleVolumeSlider(option.key)}
                                                type="button"
                                                className={neverLandUtils.classNames(
                                                    isVolumeOpen
                                                        ? "bg-indigo-800 text-white"
                                                        : "bg-gray-200 text-gray-600 hover:bg-gray-300",
                                                    "rounded-md px-2 py-1 text-xs font-medium transition-colors"
                                                )}
                                                title="볼륨 설정"
                                            >
                                              <label>🔊 볼륨조절</label>
                                              <label className="ml-1">(현재 : {currentVolume})</label>
                                            </button>
                                        )}
                                      </div>

                                      {/* <-- 토글버튼 --> */}
                                      <div className="flex items-center justify-center">
                                        <div
                                            className={`relative inline-flex h-8 w-14 cursor-pointer rounded-full transition-colors duration-300 ease-in-out ${
                                                isOptionOn ? "bg-green-500" : "bg-red-500"
                                            }`}
                                            onClick={() => toggleAlarmSetting(option.name, !option.isOn)}
                                        >
                                          <div
                                              className={`absolute top-1/2 -translate-y-1/2 transition-opacity duration-300 ${
                                                  isOptionOn ? "left-1.5" : "right-1.5"
                                              }`}
                                          >
                                            {isOptionOn ? <RiCheckFill className="h-5 w-5 text-white"/> :
                                                <RiCloseFill className="h-5 w-5 text-white"/>}
                                          </div>

                                          <div
                                              className={`absolute top-1 h-6 w-6 rounded-full bg-white shadow-md transition-transform duration-300 ease-in-out ${
                                                  isOptionOn ? "translate-x-7" : "translate-x-1"
                                              }`}
                                          />
                                        </div>
                                      </div>

                                      {/* <-- 기존 못생긴 토글 --> */}
                                      {/*<div*/}
                                      {/*    className="flex flex-row justify-center ring-2 ring-gray-900 rounded-xl bg-white">*/}
                                      {/*  <button*/}
                                      {/*      onClick={() => toggleAlarmSetting(option.name, true)}*/}
                                      {/*      type="button"*/}
                                      {/*      className={neverLandUtils.classNames(isOptionOn ? "bg-gray-900 text-white" : "bg-white text-gray-900"*/}
                                      {/*          , "whitespace-nowrap rounded-xl px-2 py-1 text-xs font-semibold shadow-sm")}*/}
                                      {/*  >*/}
                                      {/*    ON*/}
                                      {/*  </button>*/}
                                      {/*  <button*/}
                                      {/*      onClick={() => toggleAlarmSetting(option.name, false)}*/}
                                      {/*      type="button"*/}
                                      {/*      className={neverLandUtils.classNames(isOptionOn ? "bg-white text-gray-900" : "bg-gray-900 text-white"*/}
                                      {/*          , "whitespace-nowrap rounded-xl px-1.5 py-1 text-xs font-semibold shadow-sm")}*/}
                                      {/*  >*/}
                                      {/*    OFF*/}
                                      {/*  </button>*/}
                                      {/*</div>*/}
                                    </div>

                                    {/* <-- 볼륨조절 --> */}
                                    {category.title === '알람' && volumeToggleStates[option.key] &&
                                        <VolumeRangeSlider
                                            initialValue={currentVolume}  // 변수 사용
                                            onChange={(newVolume) => toggleAlarmSetting(option.name, isOptionOn, newVolume)}
                                            isOn={isOptionOn}
                                        />
                                    }
                                  </div>
                              )
                            })}
                          </div>

                        </div>
                      </div>
                  )
                })}
              </div>

              <div className=" flex justify-end ">
                <button className="text-gray-500 mr-16 mb-5 text-sm"
                        onClick={() => {
                          updateMyInfo(navigate)
                        }}
                >
                  ※ 로그인 갱신
                </button>
              </div>

              {/*<div className="flex justify-center">*/}
              {/*  <button*/}
              {/*      onClick={saveMySetting}*/}
              {/*      className={neverLandUtils.classNames("bg-blue-900 hover:bg-blue-800", "rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm")}*/}
              {/*  >*/}
              {/*    설정 저장*/}
              {/*  </button>*/}
              {/*</div>*/}

            </main>
          </div>
        </div>
      </>
  )
}
export default MySettingPage;